import {
  CLEAR_MODEL,
  FETCH_MODEL,
  UPDATE_MODEL,
  FETCH_MODEL_VERSIONS,
  CHECK_FCC_ID
} from 'actions/types';

const fetchModel = (action, state) => {
  if (!action.payload.data) return state;
  return {
    ...state,
    info: action.payload.data.data
    // versions: null,
    // selectedVersion: null
  };
};

const fetchVersions = (action, state) => {
  if (!action.payload.data) return state;
  return { ...state, versions: action.payload.data.data };
};

const checkFccId = (action, state) => {
  if (!action.payload.data || !action.payload.data.data)
    return { ...state, gcode: null };
  const gcode = action.payload.data.data.gcode;
  return { ...state, gcode };
};

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_MODEL:
      return fetchModel(action, state);
    case FETCH_MODEL_VERSIONS:
      return fetchVersions(action, state);
    case UPDATE_MODEL:
      return { ...state, ...action.payload };
    case CLEAR_MODEL:
      return null;
    case CHECK_FCC_ID:
      return checkFccId(action, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/model.js